import { http } from "@/utils/http";
import { baseApi } from "./utils";

type Result = {
  success: boolean;
  data: Array<any>;
};

export const getmenusApi = () => {
  return http.request<Result>("get", baseApi("platform/user/menu"));
};
